import { ReportDepositItem, ReportWithdrawItem } from "./types";

import { httpClient } from "@/http";

export const ReportService = {
  /** 代收日報表 */
  dailyReportDeposit() {
    return httpClient<HttpResponse<{ items: ReportDepositItem[] }>>().get(
      "/api/v1/user/me/report/daily-deposit"
    );
  },
  /** 代付日報表 */
  dailyReportWithdraw() {
    return httpClient<HttpResponse<{ items: ReportWithdrawItem[] }>>().get(
      "/api/v1/user/me/report/daily-withdraw"
    );
  },
};
